import { BILLING_PAYMENTS_TAB_FEATURE } from "constants/feature-flags";

import inSection from "./in-section.util";

// Billing renders its own menu only with the Payments tab flag on; without it
// the section is the invoices list, which the top-level Billing entry opens.
export const BILLING_DESTINATIONS = inSection("/billing", [
  {
    to: "invoices",
    label: "Invoices",
    featureFlag: BILLING_PAYMENTS_TAB_FEATURE
  },
  {
    to: "payments",
    label: "Payments",
    featureFlag: BILLING_PAYMENTS_TAB_FEATURE
  }
]);
